import React from 'react'
import GuessWord from './GuessWord'

type Props = {
  guesses: string[]
  guessCount: number
  word: string
}

const Guesses = ({ guessCount, guesses, word }: Props) => {
  return (
    <>
      <div className="flex flex-col justify-center">
        <div className="mt-10"></div>
        {guesses.map((guess, i) => (
          <GuessWord guess={guess} key={`${word}-${i}`} submitted={i < guessCount} word={word} />
        ))}
      </div>
    </>
  )
}

export default Guesses
